<template>
    <v-dialog v-model="dialog" :persistent="isPersistent" width="300px">
        <v-card class="scroll-y" style="height: 200px">
            <v-card-title class="justify-center">{{ this.display_text }}</v-card-title>
            <div align="center">
                <v-progress-circular :size="70" :width="7" color="primary" :value="value">{{ value }}</v-progress-circular>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props:{
            display_text: {
                type: String,
                default: 'Please wait'
            },
            isPersistent: {
                type: Boolean,
                default: false
            },
            timerStep: {
                type: Number,
                default: 10
            },
            timerStepMax: {
                type: Number,
                default: 100
            },
            timerInterval: {
                type: Number,
                default: 2000
            }        
        },
        data() {
            return {
                dialog: false,
                pleaseWait: {},
                interval: {},
                value: 0
            }
        },
        beforeDestroy() {
            clearInterval(this.interval)
        },
        methods: {
            open() {
                this.value = 0;
                this.interval = setInterval(() => {
                    if (this.value === this.timerStepMax) {
                        return (this.value = 0)
                    }
                    this.value += this.timerStep
                }, this.timerInterval)
                this.dialog = true;
            },
            close() {
                this.dialog = false;
            },
        },
    };
</script>

